// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19sZs","type":"styles_type__4wrPY","choices":"styles_choices__1DrY-"};